import type { Item } from "./items";
import type { Product } from "./products";

export enum TaskType {
  IN_MAINTENANCE = "in_maintenance",
  IN_RETRIEVAL = "in_retrieval",
  SENDING_TO_CUSTOMER = "sending_to_customer",
  DISPATCHED_TO_FIELD = "dispatched_to_field",
  DISPATCHED_TO_SECOND_PLANT = "dispatched_to_second_plant",
}

export enum TaskExportFormat {
  CSV = "csv",
  PDF = "pdf",
}

export enum TicketStatus {
  Requested = "todo",
  InProgress = "in_progress",
  Done = "done",
  ProblemTickets = "problem",
}

export interface CreateTicketPayload {
  items?: number[];
  products?: number[];
  /** Legacy fixed task list — only present on tickets created before the status redesign. */
  task?: TaskType;
  /** Item status the ticket targets, from the client's allowed statuses. */
  item_status: string;
  deadline: string;
  notify_email?: string;
  person_in_charge?: string;
  problem_details?: string;
  export_format?: TaskExportFormat;
  customize_columns?: Record<string, string>;
  status: TicketStatus;
  /** Index of the card inside its board column, 0 = top. */
  position?: number;
}

export interface Ticket {
  id: number;
  item_id: number;
  /** Legacy fixed task — null on tickets created after the status redesign. */
  task: string | null;
  /** Item status the ticket targets — null on tickets created before the redesign. */
  item_status: string | null;
  deadline: string;
  notify_email: string;
  person_in_charge: string;
  status: TicketStatus;
  problem_details: string | null;
  /** Index of the card inside its board column, 0 = top. */
  position: number;
  customize_columns: string[];
  createdAt: string;
  updatedAt: string;
  items?: Item[];
  products?: Product[];
}

/** An item the backend recommends attaching to a category ticket. */
export interface SuggestedItem {
  id: number;
  status: string | null;
  /** When the item entered its current status. */
  last_moved: string;
  /** Whole days the item has been sitting in its current status. */
  idle_days: number;
}

export interface TicketAnalytics {
  statusCounts: Record<TicketStatus, number>;
  /** Keyed by item status; legacy tickets are counted under their old task. */
  itemStatusCounts: Record<string, number>;
}
